import { Button } from '@chakra-ui/react';
import React from 'react';

import SelectedFloatingFooter from 'components/Table/SelectedFloatingFooter/SelectedFloatingFooter';

interface IEmployeeMappingTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleBulkEmployeeMap: (value: any[]) => void;
  isLoading: boolean;
  t: any;
}

const EmployeeMappingTableFooter: React.FC<IEmployeeMappingTableFooter> = ({
  selectedFlatRows,
  toggleAllRowSelected,
  handleBulkEmployeeMap,
  isLoading,
  t,
}) => {
  const selected = selectedFlatRows.map((item: any) => item.original.id);

  return (
    <SelectedFloatingFooter selectedFlatRows={selectedFlatRows} toggleAllRowSelected={toggleAllRowSelected}>
      <Button isLoading={isLoading} onClick={() => handleBulkEmployeeMap(selected)} variant="primary-ghost">
        {t('integrations:mapEmployees')}
      </Button>
    </SelectedFloatingFooter>
  );
};

export default EmployeeMappingTableFooter;
